import React, {useRef, useState} from 'react';
import ActivityTable from './activity_table';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import {Button, Divider, Input, Space} from 'antd';
import {SearchOutlined} from '@ant-design/icons';
import dayjs from 'dayjs';
import serviceHelper from '../../../helpers/functions/service.helper';
import CustomerService from "../../../services/ewallet_integration/customer.service";
import moment from "moment";
import globalHelper from "../../../helpers/functions/global.helper";
import TransactionTypeFilter from "./transaction_type_filter";
import DatePickerFilter from "./dateFilter";

const ActivityListingLayout = ({default_filter}) => {
    const {innerWidth} = window;
    const componentRef = useRef();
    const [exportLoading, setExportLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [timer, setTimer] = useState(null);
    const [state, setState] = useState({
        customers: []
    });

    const [filter, setFilter] = useState({
        search: default_filter?.search,
        transaction_types: default_filter?.transaction_types,
        start_date: default_filter?.start_date,
        end_date: default_filter?.end_date,
    });

    const onChange = (key, checkedValues) => {
        setFilter(filter => ({...filter, [key]: checkedValues}))
        changeFilter(key, checkedValues);
    }

    // for changing filter
    const changeFilter = (key, value) => {
        let generate_filter = default_filter;
        generate_filter[key] = value;
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }

    const changeDate = (key1, key2, date) => {
        if(date){
            const start_date = dayjs(date[0])?.format("YYYY-MM-DD");
            const end_date = dayjs(date[1])?.format("YYYY-MM-DD");

            setFilter(filter => ({...filter, [key1] : start_date, [key2] : end_date}));
            changeFilter(key1, start_date);
            changeFilter(key2, end_date);
        }else{
            setFilter(filter => ({...filter, [key1] : null, [key2] : null}));
            changeFilter(key1, null);
            changeFilter(key2, null);
        }
    }

    const exportExcel = async () => {
        setExportLoading(true);
        const { customer_ids, search,transaction_types, start_date, end_date } = filter;
        const response = await CustomerService?.activity_listings({
            // filter
            search,
            customer_ids,
            transaction_types,
            start_date,
            end_date,
            is_all: true,
            // order
            order : "created_at",
            order_position : 'DESC',
        });
        const {  rows, count } = response?.data?.activity_listings;

        const exportRows = rows.map((v, index) => {
            const {
                transaction_type_code,
                transaction_type,
                transaction_no,
                running_number,
                from_merchant_name,
                to_merchant_name,
                from_customer_name,
                to_customer_name,
                from_customer_phone,
                to_customer_phone,
                from_wallet_name,
                to_wallet_name,
                melon_amount,
                created_at,
                activity_status_name,
                refund = {},
                redemption = {},
                payment = {},
                topup = {},
                merchant_settlement = {},
            } = v;

            // Resolve merchant name (logic can be adjusted as needed)
            let merchantName = "-";
            let customerName = '-';
            let customerPhone = '-';
            let paymentAmount = '0.00';
            let face_url = '-';
            let redemption_code = '-';
            let redemption_reference_no = '-';
            let refund_transaction_code = '-';
            switch(transaction_type_code) {
                case 'REFUND':
                    merchantName = from_merchant_name || "-";
                    customerName = to_customer_name || '-';
                    customerPhone = to_customer_phone || '-';
                    refund_transaction_code = refund?.payment?.activity?.transaction_no || '-';
                    break;
                case 'PAYMENT':
                    merchantName = to_merchant_name || "-";
                    customerName = from_customer_name || "-";
                    customerPhone = from_customer_phone || '-';
                    face_url = payment?.face_url || '-';
                    break;
                case 'SETTLEMENT':
                    merchantName = from_merchant_name || "-";
                    paymentAmount = merchant_settlement?.payment_amount || '0.00';
                    break;
                case 'TOPUP':
                    customerName = to_customer_name || "-";
                    customerPhone = to_customer_phone || '-';
                    paymentAmount = topup?.payment_amount || '0.00';
                    break;
                case 'REDEMPTION':
                    customerName = to_customer_name || "-";
                    customerPhone = to_customer_phone || '-';
                    paymentAmount = redemption?.payment_amount || '0.00';
                    redemption_code = redemption?.redemption_code?.code || '-';
                    redemption_reference_no = redemption?.reference_no || '-';
                    break;
            }



            return {
                "No": index + 1,
                "Transaction No.": transaction_no || "-",
                "Running No.": running_number || "-",
                "Type": transaction_type?.name || transaction_type_code || "-",
                "Status": activity_status_name || "-",
                "Merchant": merchantName,
                "Customer": customerName,
                "Customer Phone": customerPhone || "-",
                "From Wallet": from_wallet_name || "-",
                "To Wallet": to_wallet_name || "-",
                "Face": face_url || "-",
                "Refund Transaction No.": refund_transaction_code || "-",
                "Redemption Code": redemption_code || "-",
                "Redemption Reference No": redemption_reference_no || "-",
                "Payment Amount": Number(paymentAmount || 0).toFixed(2),
                "Melon Amount": Number(melon_amount || 0).toFixed(2),
                "Date": moment(created_at)?.isValid()
                    ? moment(created_at).format("DD MMM YYYY HH:mm")
                    : "-"
            };
        });


        globalHelper.exportToExcel({
            data: exportRows,
            name: `activities_${moment()?.format("YYYYMMDD")}`,
        });

        setExportLoading(false);
    }

    const doneTyping = async (input) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setFilter(filter => ({ ...filter, search: input, }));
            changeFilter('search', input);
        }, 300);
        setTimer(newTimer);
    }

    return (
        <>
            <div className='mobile-padding-12'>
                <div style={{marginBottom: 24, textAlign: 'start'}}>
                    <PageHeaderComponent title={'Activity Listing'}/>
                </div>
                <div>
                    <Input
                        onChange={(e) => doneTyping(e.target.value)}
                        name="search"
                        defaultValue={filter?.search}
                        prefix={<SearchOutlined style={{color: 'var(--secondary-text-color)'}}/>}
                        placeholder='Search'
                        style={{minWidth: '100%',}}
                        allowClear
                        // {...(errors?.find(x => x?.type === 'search_length') && ({ status : 'warning', }))}
                    />
                    <div style={{display: 'flex', alignItems: 'center', marginTop: 12, gap: 8,}}>
                        <div style={{textAlign: 'start',}}>
                            <Space direction={innerWidth > 768 ? 'horizontal' : 'vertical'}>
                                <TransactionTypeFilter
                                    searchText={searchText}
                                    setSearchText={setSearchText}
                                    filter={filter}
                                    onChange={onChange}
                                />

                                <DatePickerFilter
                                    filter={filter}
                                    changeDate={changeDate}
                                />
                            </Space>
                        </div>
                        <div style={{marginLeft: 'auto'}}>
                            <Button loading={exportLoading} onClick={() => exportExcel()}>
                                Export
                            </Button>
                        </div>
                    </div>
                </div>

                <Divider/>
                <div ref={componentRef} style={{marginTop: 12,}}>
                    <ActivityTable filter={filter}/>
                </div>
            </div>
        </>
    );
}

export default ActivityListingLayout;